export const enum LinkItemCode {
    Home = 0,
    Guide = 1,
    OnDemand = 2,
    MyTv = 3,
    Settings = 4,
    Search = 5,
    Channels = 6,
    NewShows = 7,
    NewMovies = 8,
    RecommendedShows = 9,
    RecommendedMovies = 10,
    SubGenres = 11,
    SubGenresContent = 12,
    Account = 13,
    Subscription = 14,
    Favorites = 15,
    Privacy = 16,
    About = 17,
    LogInSignIn = 18,
    Details = 19,
    Login = 20,
    Player = 22,
    DetailsSeries = 23,
    DetailsMovies = 24,
    DetailsPrograms = 25,
    ShowAllRecentChannels = 26,
    ShowAllMovies = 27,
    ShowAllKids = 28,
    ShowAllNews = 29,
    ShowAllSports = 30,
    SearchChannels = 31,
    SearchLiveTV = 32,
    SearchMovies = 33,
    SearchShows = 34,
    SearchCastAndCrew = 35,
    Error = 36,
    ParentalControl = 37,
    Trailer = 38,
    LogInForgot = 39,
    SettingsPlayer = 40,
    ShowAllMostPopular = 42,
    ShowAllContinueWatching = 43,
    ShowAllWatchAgain = 44,
    ShowAllHomeTrends = 46,
    LogInWelcomeScreen = 47,
    Help = 48,
    Language = 49,
    SubGenrePremium = 50,
    Root = 100,
    allOnDemand = 101,
    favChannels = 102,
    allPrograms = 103,
    DetailGenre = 104,
    DevMode = 105,
    softwareLicense = 106,
    freedomService = 107,
    ShowAllHomeMovies = 108,
    ShowAllHomeSports = 109,
    ShowAllHomeKids = 110,
    ShowAllHomeNews = 111,
    ShowAllHomelRecentlyOnDemand = 112,
    ShowAllHomeOlympics = 113,
    ShowAllHomeContinueWatching = 114,
    ShowAllHomeWatchAgain = 115,
    ShowAllHome = 116,
    ShowAllVod = 117,
    ShowAllVodRecentlyOnDemand = 118,
    ShowAllSearch = 119,
    ShowAllHomeLiveSeries = 120,
    ClearCache = 121,
    ShowAllVodAllMovies = 122,
    DetailCast = 123,
};
